<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>تنظیمات</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.ids.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.ids.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.send_emergency_sms.val"
                                        :description="form.send_emergency_sms.inv"
                                        label="ارسال پیام اطلاع ‌رسانی"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.send_emergency_sms.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.send_emergency_sms_to.val" :description="form.send_emergency_sms_to.inv" dir="ltr" label="شماره موبایل" />
                                    <small>الگوی نمونه: 989122030348</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.account_balance_limit.val" :description="form.account_balance_limit.inv" dir="ltr" label="محدودیت شارژ (ریال)" />
                                    <small>با تعیین محدودیت شارژ، در صورتی که شارژ شما کمتر از آن مقدار شود، از طریق پیام به شما اطلاع رسانی می گردد.</small>
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> ارسال</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
				ids: {val: '', inv: '', v: { req: true, max: 8 }},
                send_emergency_sms: {val: '', inv: '', v: { req: true, max: 512 }},
                send_emergency_sms_to: {val: '', inv: '', v: { req: true, max: 512, spec: 'mobile-number' }},
                account_balance_limit: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
            users: [],
        }
    },
    mounted() {
        this.get_users();
	},
    methods: {
        get_users(){
            this.axios.get('users/?type=update_users')
            .then(res => {
                res.data.map(val => {
                    this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                });
            })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                   if(key == 'ids'){
                       data.set(key, JSON.stringify([parseInt(this.form[key].val)]));
                   } else {
                        data.set(key, this.form[key].val);
                   }
                }
                this.axios.put('users/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'ارسال با موفقیت انجام شد.'
                        });
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.update_all_users == false
            && this.$store.state.perms.update_same_group_users == false
            && this.$store.state.perms.update_same_group_users == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
